import { useState } from "react";

export const useModalManager = (modalList = []) => {
  const initialState = modalList.reduce((acc, name) => {
    acc[name] = false;
    return acc;
  }, {});

  const [modals, setModals] = useState(initialState);
  const [modalPayload, setModalPayload] = useState({});

  const openModal = (name, payload = null) => {
    setModals((prev) => ({ ...prev, [name]: true }));
    if (payload !== null) {
      setModalPayload((prev) => ({ ...prev, [name]: payload }));
    }
  };

  const closeModal = (name) => {
    setModals((prev) => ({ ...prev, [name]: false }));
    setModalPayload((prev) => {
      const { [name]: _, ...rest } = prev;
      return rest;
    });
  };

  const isOpen = (name) => !!modals[name];
  const getPayload = (name) => modalPayload[name];

  return {
    openModal,
    closeModal,
    isOpen,
    getPayload,
  };
};
